import { z } from "zod";

export const candidateFileIdSchema = z
  .string()
  .min(1)
  .brand<"CandidateFileId">();
